import { mapActions, mapGetters } from 'vuex';
import mvtWeatherCard from '@/common/components/mvtweathercard/mvt-weathercard.vue';
import mvtDropdownList from '@/common/components/mvtdropdownlist/mvt-dropdownlist.vue';
import mvtBreadcrumb from '@/common/components/mvtbreadcrumb/mvt-breadcrumb.vue';
import mvtNewMap from '@/common/components/mvtnewmap/mvt-newmap.vue';
import { CustomControl } from 'vue3-google-map';

export default {
    name: 'neighborhoodMap',
    props: {
        geo: Object,
        boundary: Object,
        listings: Array,
        weather: Object,
    },
    inject: ['$eventBus'],
    components: {
        CustomControl,
        mvtNewMap,
        mvtDropdownList,
        mvtWeatherCard,
        mvtBreadcrumb,
    },
    data() {
        return {
            viewOptions: [
                {
                    text: 'Homes for sale',
                    value: 'homes',
                    icon: 'icon-house',
                },
                {
                    text: 'Traffic',
                    value: 'traffic',
                    icon: 'icon-car',
                },
                {
                    text: 'Biking',
                    value: 'biking',
                    icon: 'icon-bicycle',
                },
            ],
            selectedViewOption: 'homes',
        };
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        filteredListings() {
            if (this.selectedViewOption === 'homes') {
                return this.listings.filter((listing) => listing.geo && listing.geo.lat && listing.geo.lng);
            }
            return [];
        },
        breadcrumbGeo() {
            return {
                statePath: `${this.geo.state.toLowerCase()}/`,
                cityPath: `${this.geo.city.replace(/ /g, '-')}-${this.geo.state}/`.toLowerCase(),
                neighborhood: this.geo.neighborhoodName,
                homeText: 'Home',
                stateFullName: this.geo.state,
                ...this.geo,
            };
        },
    },
    watch: {
        selectedViewOption(value) {
            this.updateMapLayer(value);
        },
    },
    methods: {
        ...mapActions('glb', ['getBoundaries']),
        updateMapLayer(layer) {
            const map = this.$refs.mapRef;
            if (map) {
                if (layer === 'biking' || layer === 'traffic') {
                    map.changeMapLayer(layer);
                } else {
                    map.resetMapPosition();
                    map.changeMapLayer(null);
                }
            }
        },
    },
};
